import { reskinStyles } from 'core/components/theme/theme-variant';
import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  iconButtonRoot: {
    color: theme.colors.action_icon,
    padding: 0,
    ...reskinStyles(theme, { padding: theme.spacing(1), alignSelf: 'center' })
  },
  iconButtonLabel: {
    height: 24,
    width: 24,
    '& > img': {
      height: 24,
      width: 24
    }
  },
  'big-iconButtonRoot': {
    color: theme.colors.action_icon,
    padding: theme.spacing(2)
  },
  'big-iconButtonLabel': {
    height: 32,
    width: 32,
    '& > img': {
      height: 32,
      width: 32
    }
  },
  tooltip: {
    margin: theme.spacing(0, 1),
    backgroundColor: theme.colorPalette.green_75,
    fontSize: 14
  }
});

export default makeStyles(styles);
